import { useDispatch, useSelector } from 'react-redux';
import { DTSelectActionReasonView, AVAILABLE_FIELDS_CONFIG } from '../../DTSelectActionReasonView';
import SelectInputs from '../../Common/SelectInputs/SelectInputs';
import { getActionReasons, getCancelOrRefundReasonOptions } from '../../../../../../extractFromState';
import { addEdgeToDecisionTreePath } from '../../../../../../actions/searchActions';

const DTSelectCancelOrRefundReasonNode = () => {
  const dispatch = useDispatch();

  const cancelRefundReasonOptions = useSelector(getCancelOrRefundReasonOptions);
  const actionReasons = useSelector(getActionReasons);
  const handleNextButtonClick = () => dispatch(addEdgeToDecisionTreePath('reason_selected'));

  return (
    <DTSelectActionReasonView
      isNextButtonActive={actionReasons?.cancelOrRefundPrimaryReason}
      onNextButtonClick={handleNextButtonClick}
    >
      <SelectInputs
        placeholder="Select cancel or refund reason"
        options={cancelRefundReasonOptions}
        fields={AVAILABLE_FIELDS_CONFIG.cancelOrRefundReason}
      />
    </DTSelectActionReasonView>
  );
};

export default DTSelectCancelOrRefundReasonNode;
